module.exports = __webpack_public_path__ + "static/media/tools.5ebc7a77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/tools.svg
// module id = 275
// module chunks = 3